import { SessionDetail, SessionPhoto, SessionVideo } from "@/utils/types"

export function isExpectedResultsEnabled(detail: SessionDetail): boolean {
  const { expectedInfoScreenEnabled, expectedBrand, expectedLicensePlate, expectedOdo, expectedVin } = detail
  return expectedInfoScreenEnabled && [expectedBrand, expectedLicensePlate, expectedOdo, expectedVin].some((val) => val)
}

type IsIntroStepFinishedParams = {
  photos: SessionPhoto[]
  videos: SessionVideo[]
  detail: SessionDetail
}

export function calculateIntroStepFinished(params: IsIntroStepFinishedParams): boolean {
  const { photos, videos, detail } = params

  const sessionHasPhotos = photos.some((p) => !!p.url || p.skipped)
  const sessionHasVideos = videos.some((v) => !!v.url || v.skipped)
  const isIntroDisabled = detail.introDisabled
  const renderExpectedInfoScreen = isExpectedResultsEnabled(detail)
  const isRequirementsIntroScreenEnabled = detail.requirementsIntroScreenEnabled

  // User already got past intro (maybe on another device)
  if (sessionHasPhotos || sessionHasVideos) return true

  if (isIntroDisabled) {
    // Only these screens will show, but they are part of the intro flow
    if (renderExpectedInfoScreen || isRequirementsIntroScreenEnabled) {
      return false
    }

    return true
  }

  return false
}
